import { render, staticRenderFns } from "./SwifterUpload.vue?vue&type=template&id=2243d84e&scoped=true"
import script from "./SwifterUpload.vue?vue&type=script&lang=js"
export * from "./SwifterUpload.vue?vue&type=script&lang=js"
import style0 from "./SwifterUpload.vue?vue&type=style&index=0&id=2243d84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243d84e",
  null
  
)

export default component.exports